<template>
  <span v-show="visible" class="ui-sliding-indicator" :style="indicatorStyle" aria-hidden="true" />
</template>

<script>
export default {
  name: 'UiSlidingIndicator',
  props: { activeKey: { type: [String, Number], default: '' } },
  data: () => ({ visible: false, indicatorStyle: {} }),
  watch: { activeKey () { this.$nextTick(this.scheduleMeasure) } },
  mounted () {
    this.frame = null
    const parent = this.$el.parentElement
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.scheduleMeasure)
      this.resizeObserver.observe(parent)
    }
    this.mutationObserver = new MutationObserver(this.scheduleMeasure)
    this.mutationObserver.observe(parent, { childList: true, subtree: true, characterData: true })
    window.addEventListener('resize', this.scheduleMeasure)
    this.scheduleMeasure()
  },
  beforeDestroy () {
    if (this.frame != null) cancelAnimationFrame(this.frame)
    if (this.resizeObserver) this.resizeObserver.disconnect()
    if (this.mutationObserver) this.mutationObserver.disconnect()
    window.removeEventListener('resize', this.scheduleMeasure)
  },
  methods: {
    scheduleMeasure () {
      if (this.frame !== null || this._isDestroyed || this._isBeingDestroyed) return
      this.frame = requestAnimationFrame(() => {
        this.frame = null
        const selected = this.$el.parentElement.querySelector('.is-current')
        this.visible = this.activeKey !== '' && Boolean(selected)
        if (this.visible) this.indicatorStyle = { width: `${selected.offsetWidth}px`, transform: `translateX(${selected.offsetLeft}px)` }
      })
    }
  }
}
</script>
